import { Grid, Paper } from "@mui/material";
import React from "react";

export function Footer() {
  return (
    <Paper
      sx={{
        marginTop: "calc(10% + 70px)",
        bottom: 0,
        width: "100%",
      }}
      component="footer"
      square
    >
      <footer
        style={{
          position: " fixed",
          left: "0",
          bottom: " 0",
          width: " 100%",
          backgroundColor: " red",
          textAlign: "center",
          zIndex: "999999",
          background: " #dddedf",
          borderBottom: "5px solid #ca171f",
        }}
      >
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item>
            <img
              style={{
                paddingLeft: "30px",
                paddingTop: "10px",
                height: "50px",
              }}
              src={require("../assets/ekfc-logo.png")}
              alt=""
            />
          </Grid>
          <Grid item>
            <div style={{ paddingRight: "30px", paddingLeft: "30px" }}>
              <p style={{ fontSize: "12px" }}>
                © {new Date().getFullYear()} Emirates Flight Catering. <br />
                All Rights Reserved.
              </p>
            </div>
          </Grid>
        </Grid>
      </footer>
    </Paper>
  );
}
